import React, { useEffect, useState } from 'react'
import {
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Chip,
    Button,
    MenuItem,
} from '@mui/material'
import { Formik } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CreateIcon from '@mui/icons-material/Create';
import { toast, useToastContainer } from 'react-toastify';
import SearchIcon from '@mui/icons-material/Search';
import CategoryDialog from '../Components/CategoryDialog';
import { ClipLoader } from 'react-spinners';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};


function CategoryManagemnet() {
    const [pageTitle, setPageTitle] = useState('Category Management');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [categorySearch, setCategorySearch] = useState("");
    const [updateID, setUpdateID] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [status, setStatus] = useState(1);
    const [categotyListGrid, setCategotyListGrid] = useState([]);

    useEffect(() => {
        GetAllCategoryDetails();
    }, [])

    useEffect(() => {
        GetAllCategoryDetails();
    }, [dialogOpen])

    useEffect(() => {
        GetAllCategoryDetails();
    }, [status])

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categotyListGrid.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    function handleClick() {
        setDialogOpen(true);
    }

    function GetAllCategoryDetails() {
        axios.get('https://serverdemo.ccsoftwares.com/Category/getallcategory').then((res) => {
            if (res.data.length > 0) {
                const FilterData = res.data.filter(supplierStatus => supplierStatus.IsActive === status);
                setCategotyListGrid(FilterData);
                // setCategoryList(res.data);
                setIsLoading(false);
            } else {
                setCategoryList([]);
                toast.error("No records to display!");
            }
        })
    }

    function UpdateRowData(id) {
        setUpdateID(id);
        setDialogOpen(true);
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={11} xs={11}>
                    {titleName}
                </Grid>
                <Grid item md={1} xs={1}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' >
                        <Button variant="contained" endIcon={<AddCircleOutlineIcon />} onClick={() => handleClick()} sx={{ width: '100%' }}>
                            Add
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        )
    }
    return (
        <>
            <Container maxWidth={false} sx={{ paddingTop: '15vh' }}>
                <Formik
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form>
                            <Box mt={0}>
                                <Card sx={{ padding: '15px' }}>
                                    <CardHeader
                                        title={cardTitle(pageTitle)}
                                    />
                                    <Divider />
                                    <br />

                                    <TableContainer>
                                        <Grid container spacing={2}>
                                            <Grid item md={6} sx={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                                    <SearchIcon sx={{ color: 'action.active', mr: 1, my: 1 }} />
                                                    <TextField
                                                        sx={{ width: { md: '50%', xs: '60%' } }}
                                                        variant="outlined"
                                                        value={categorySearch}
                                                        onChange={(e) => { setCategorySearch(e.target.value) }}
                                                        size='small'
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item md={6} sx={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        onBlur={handleBlur}
                                                        name='status'
                                                        value={status}
                                                        id='status'
                                                        onChange={(e) => { setStatus(e.target.value) }}
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{ width: { md: '30%', xs: '60%' } }}
                                                    >
                                                        <MenuItem key={1} value={1}>Active</MenuItem>
                                                        <MenuItem key={0} value={0}>Inactive</MenuItem>
                                                    </TextField>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <br />
                                        <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>#</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold', textTransform: 'uppercase' }} >Category Name</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>IsActive</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(rowsPerPage > 0
                                                    ? categotyListGrid.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : categotyListGrid
                                                ).filter((element) => {
                                                    if (categorySearch === "") {
                                                        return element;
                                                    } else if ((element.CategoryName.toLowerCase().trim()).includes(categorySearch.toLowerCase().trim())) {
                                                        return element;
                                                    }
                                                }).map((row, index) => (
                                                    <TableRow key={row._id}>
                                                        <TableCell align='center'>{index + 1}</TableCell>
                                                        <TableCell align='center'>{row.CategoryName}</TableCell>
                                                        <TableCell align='center'>
                                                            {row.IsActive == 1 ? <Chip label="Active" color="primary" /> : <Chip label="Inactive" color="error" />}
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <IconButton>
                                                                <CreateIcon sx={{ color: 'black' }} onClick={() => UpdateRowData(row.CategoryID)} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                                {emptyRows > 0 && (
                                                    <TableRow style={{ height: 53 * emptyRows }}>
                                                        <TableCell colSpan={7} />
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 35, { label: 'All', value: -1 }]}
                                                        colSpan={7}
                                                        count={categotyListGrid.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        slotProps={{
                                                            select: {
                                                                inputProps: {
                                                                    'aria-label': 'rows per page',
                                                                },
                                                                native: true,
                                                            },
                                                        }}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                        ActionsComponent={TablePaginationActions}
                                                    />
                                                </TableRow>
                                            </TableFooter>
                                        </Table>
                                    </TableContainer>
                                </Card>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Container>

            {/* category details dialog box */}
            <CategoryDialog
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                updateID={updateID}
                setUpdateID={setUpdateID}
            />
        </>
    )
}

export default CategoryManagemnet